module.exports = __webpack_public_path__ + "img/fight1.1f0f70f0.svg";